// extracted by mini-css-extract-plugin
export default {"Container":"Sidebar_Container__LvAkQ","Menu":"Sidebar_Menu__3uJu2"};